import { CCol, CContainer, CRow } from "@coreui/react";
import React from "react";
import SectionTitle from "../components/Common/SectionTitle";

import staticData from "../assests/staticData.json";
import Banner from "../components/Common/Banner";
import AboutBanner from "../assests/bg-about.png";
import ReferrelsForm from "../components/Forms/ReferrelsForm";

export default function Referrels() {
  const { referrels_content } = staticData;
  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"Registered NDIS Provider"}
        text={"Referrals"}
      />
      <section className="referrels-section-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={12}>
              <div className="">
                <SectionTitle
                  align={"left"}
                  subTitle={"Referrals"}
                  subtitle={false}
                  Title={"Referrals"}
                />
              </div>
              <div>
                <p className="themeGrayPara in-fs lh-28">
                  {referrels_content?.referrals?.referral_text}
                </p>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-lg-5 mb-lg-5 mt-0 mb-0">
            <CCol lg={12}>
              <div className="referrels-form-card-wrapper">
                <ReferrelsForm />
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg={12}>
              <div className="">
                <SectionTitle
                  align={"left"}
                  subTitle={"Privacy Statement"}
                  subtitle={false}
                  Title={"Privacy Statement"}
                />
              </div>
              <div>
                <p className="themeGrayPara in-fs lh-28">
                  {referrels_content?.privacy?.privacy_text}
                </p>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
